import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

type UseRiskAssessmentsParams = {
  residentId: string
  enabled?: boolean
}

export type RiskAssessmentListItem = {
  id: string
  name?: string
  form?: { id?: string; name?: string; icon?: string }
  reviewedOn?: string
  createdOn?: string
  archived?: boolean
  consentForms?: string[]
}

export const useRiskAssessments = <TItem = RiskAssessmentListItem>({
  residentId,
  enabled = true
}: UseRiskAssessmentsParams) => {
  const { data, isLoading, error, refetch } = useQuery(
    ['risk-assessments', residentId, 'mostRecent'],
    () =>
      getJSON({
        // mostRecent collapses each assessment to its current version; without
        // it the list returns every historic version (CM-4053).
        url: `/api/list/risk-assessments?resident=${residentId}&mostRecent=true`
      }),
    {
      enabled: enabled && !!residentId,
      refetchOnMount: 'always'
    }
  )

  return {
    data: (data?.result || []) as TItem[],
    isLoading,
    error,
    refetch
  }
}
